import React, { Fragment, useEffect, useState, useMemo, useCallback, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Table, Button, Card, CardBody, Col, Container, CardHeader, Nav, NavItem, NavLink, Row, Modal, ModalHeader, Form, ModalBody, Label, Input, FormFeedback, Spinner } from "reactstrap";
import moment from "moment";
import "moment-timezone";
import handleValidDate from "../../../../helpers/utils/handleValidDate";
import BreadCrumb from "../../../../Components/Common/BreadCrumb";
import { isEmpty } from "lodash";
import { useTable, useGlobalFilter, useAsyncDebounce, useSortBy, useFilters, useExpanded, usePagination, useRowSelect } from "react-table";

import Flatpickr from "react-flatpickr";
import Select from "react-select";

//Import actions

import ExportCSVModal from "../../../../Components/Common/ExportCSVModal";
import ExportDoc from "../../../../Components/Common/ExportDoc";
import { getAccAccount, getAccCategory, resetAccCategoryState } from "../../../../store/actions";
import Export from "./Export";

const ProfitLoss = () => {
  const dispatch = useDispatch();
  const { clientSelected, companySelected, branchSelected, userData, userType, userRole, accCategories, isAccCategoryCreated, isAccCategorySuccess, loading, error, accAccounts, loadingAccAccounts } = useSelector((state) => ({
    clientSelected: state.App.clientSelected,
    companySelected: state.App.companySelected,
    branchSelected: state.App.branchSelected,
    userData: state.App.userData,
    userRole: state.App.userRole,
    userType: state.App.userType,
    accCategories: state.AccCategory.accCategories,
    isAccCategoryCreated: state.AccCategory.isAccCategoryCreated,
    isAccCategorySuccess: state.AccCategory.isAccCategorySuccess,
    loading: state.AccCategory.loading,
    error: state.AccCategory.error,
    accAccounts: state.AccAccount.accAccounts,
    loadingAccAccounts: state.AccAccount.loading,
  }));

  // const [dataTreeAccount, setDataTreeAccount] = useState([]);
  const [dataReport, setDataReport] = useState({
    pendapatan: null,
    bebanPokokPendapatan: null,
    bebanOperasional: null,
    pendapatanLainnya: null,
  });

  const [filterDate, setFilterDate] = useState({
    start: null,
    end: null,
  });
  // const [dataPendapatan, setDataPendapatan] = useState(null);
  // const [dataBebanPokokPendapatan, setDataBebanPokokPendapatan] = useState(null);
  // const [dataBebanOperasional, setDataBebanOperasional] = useState(null);
  // const [dataPendapatanLainnya, setDataPendapatanLainnya] = useState(null);

  const buildAccountTree = (items) => {
    const itemMap = new Map();
    const roots = [];

    items.forEach((item) => {
      const node = {
        id: item.id,
        name: item.name,
        code: item.code,
        sort_order: item.sort_order,
        type: item.type,

        parentId: item.parentId,
        childrens: [],
      };

      itemMap.set(item.id, node);

      if (item.parentId === null) {
        roots.push(node);
      }
    });

    items.forEach((item) => {
      if (item.parentId !== null) {
        const parentNode = itemMap.get(item.parentId);
        if (parentNode) {
          parentNode.childrens.push(itemMap.get(item.id));
        }
      }
    });

    roots.sort((a, b) => a.sort_order - b.sort_order);

    function sortChildren(node) {
      node.childrens.sort((a, b) => a.sort_order - b.sort_order);
      node.childrens.forEach(sortChildren);
    }

    roots.forEach(sortChildren);

    return roots;
  };

  function isDateBetween(dateToCheckString, startDateString, endDateString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date(startDateString);
    const endDate = new Date(endDateString);

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime()) || isNaN(endDate.getTime())) {
      console.error("Invalid date format provided.");
      return false;
    }

    return dateToCheck >= startDate && dateToCheck <= endDate;
  }

  function attachAccountsToTree(treeRoots, accounts, startDate = null, endDate = null) {
    const categoryMap = new Map();

    function collectCategories(node) {
      if (node.id) {
        categoryMap.set(node.id, node);
      }
      node.childrens.forEach(collectCategories);
    }

    treeRoots.forEach(collectCategories);

    accounts.forEach((account) => {
      const categoryId = account.categoryId;
      if (!categoryId) return;

      const targetCategory = categoryMap.get(categoryId);
      if (!targetCategory) {
        console.warn(`Kategori ID ${categoryId} tidak ditemukan di tree`);
        return;
      }

      let temp_saldo_close = 0;

      let valAccClose = "";
      if (Array.isArray(account.acc_account_close) && account.acc_account_close.length > 0) {
        valAccClose = account.acc_account_close[account.acc_account_close.length - 1];
      }

      let debitClose = valAccClose.debit ? parseFloat(valAccClose.debit) : 0;
      let creditClose = valAccClose.credit ? parseFloat(valAccClose.credit) : 0;

      if (debitClose > 0) temp_saldo_close += debitClose;
      if (creditClose > 0) temp_saldo_close -= creditClose;

      let headerSaldo = temp_saldo_close;

      for (const trx of account.acc_account_trans_detail || []) {
        let headerDebit = trx.debit ? parseFloat(trx.debit) : 0;
        let headerCredit = trx.credit ? parseFloat(trx.credit) : 0;

        if (startDate || endDate) {
          if (isDateBetween(handleValidDate(trx?.at_detail_trans?.transactionat, "YYYY/MM/DD"), startDate, endDate)) {
            if (headerDebit > 0) headerSaldo += headerDebit;
            if (headerCredit > 0) headerSaldo -= headerCredit;
          }
        }
        else {
          if (headerDebit > 0) headerSaldo += headerDebit;
          if (headerCredit > 0) headerSaldo -= headerCredit;
        }
      }

      const accountNode = {
        isAccount: true,
        id: account.id,
        name: account.name,
        code: account.code,
        headerSaldo: headerSaldo,
        updatedat: account.updatedat,
        childrens: [],
      };

      targetCategory.childrens.push(accountNode);
    });

    function sortChildrens(node) {
      node.childrens.sort((a, b) => {
        if (a.isAccount && !b.isAccount) return 1;
        if (!a.isAccount && b.isAccount) return -1;
        return a.code.localeCompare(b.code);
      });

      node.childrens.forEach(sortChildrens);
    }

    treeRoots.forEach(sortChildrens);

    return treeRoots;
  }

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  useEffect(() => {
    dispatch(resetAccCategoryState());
    dispatch(getAccCategory({ companyId: companySelected?.value }));
    dispatch(getAccAccount({ companyId: companySelected?.value, branchId: branchSelected?.value, status: 2, trans: true }));
  }, [companySelected, branchSelected]);

  useEffect(() => {
    if (accCategories.length > 0 && accAccounts.length > 0) {
      const tree = buildAccountTree(accCategories);
      const updatedTree = attachAccountsToTree(tree, accAccounts, filterDate.start, filterDate.end);

      const profitLossData = updatedTree.filter((item) => ["4", "6"].includes(item.code));
      const pendapatan = {
        label: "Pendapatan",
        data: profitLossData[0].childrens.filter((item) => item.isAccount),
        total: profitLossData[0].childrens.filter((c) => c.isAccount)?.reduce((sum, acc) => sum + (acc.headerSaldo || 0), 0) || 0,
      };
      const bebanPokokPendapatan = {
        label: "Beban Pokok Pendapatan",
        data: profitLossData[1].childrens[0].childrens.filter((item) => item.isAccount),
        total: profitLossData[1].childrens[0].childrens.filter((item) => item.isAccount)?.reduce((sum, acc) => sum + (acc.headerSaldo || 0), 0) || 0,
      };
      const bebanOperasional = {
        label: "Beban Operasional",
        data: profitLossData[0].childrens[1].childrens.filter((item) => item.isAccount),
        total: profitLossData[0].childrens[1].childrens.filter((item) => item.isAccount)?.reduce((sum, acc) => sum + (acc.headerSaldo || 0), 0) || 0,
      };
      const pendapatanLainnya = {
        label: "Pendapatan Lain-Lain",
        data: profitLossData[0].childrens[0].childrens.filter((item) => item.isAccount),
        total: profitLossData[0].childrens[0].childrens.filter((item) => item.isAccount)?.reduce((sum, acc) => sum + (acc.headerSaldo || 0), 0) || 0,
      };

      setDataReport((prevVal) => {
        return {
          ...prevVal,
          pendapatan: pendapatan,
          bebanPokokPendapatan: bebanPokokPendapatan,
          bebanOperasional: bebanOperasional,
          pendapatanLainnya: pendapatanLainnya,
        };
      });

      // setDataTreeAccount(profitLossData);
    }
  }, [accCategories, accAccounts, filterDate]);

  // Column

  document.title = "Laporan Tanda Jadi Harian | Enterprise Resources Planning";
  return (
    <div className="page-content">
      {/* <ExportCSVModal show={isExportCSV} onCloseClick={() => setIsExportCSV(false)} data={accTransList} /> */}
      <Container fluid>
        <BreadCrumb title="Laba Rugi" pageTitle="Keuangan" loading={loading || loadingAccAccounts}>
          <div className="d-flex align-items-center">
            <div className="search-box me-2 mb-0">
              <Flatpickr
                className="form-control"
                id="datepicker-publish-input"
                placeholder="Pilih Tanggal"
                options={{
                  mode: "range",
                  dateFormat: "Y/m/d",
                }}
                onChange={(selectedDates, dateStr) => {
                  if (!dateStr) {
                    setFilterDate({ start: null, end: null });
                    return;
                  }

                  const [start, end] = dateStr.split(" to ");
                  setFilterDate({ start: start ? start : null, end: end ? end : null });
                }}
              />
              <i className="bx bx-calendar-alt search-icon"></i>
            </div>

            <Export data={dataReport} />
          </div>
        </BreadCrumb>
        <Row>
          <Col lg={12}>
            <Card>
              <CardBody className="pt-1">
                {loading || loadingAccAccounts ? (
                  <div className="text-center py-4 text-muted">
                    <p>Memuat data...</p>
                  </div>
                ) : (
                  <div className="p-3">
                    <div>
                      <div className="fw-bold p-2 border-bottom bg-light">{dataReport.pendapatan?.label}</div>
                      <div style={{ marginLeft: "20px" }}>
                        {dataReport.pendapatan?.data.map((account, i) => {
                          return (
                            <div key={account.code} className="p-2 d-flex justify-content-between align-items-center border-bottom">
                              <span>
                                {account.code} - {account.name}
                              </span>
                              {account.headerSaldo < 0 ? `(${currencyFormat(Math.abs(account.headerSaldo))})` : currencyFormat(account.headerSaldo)}
                            </div>
                          );
                        })}
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Total dari {dataReport.pendapatan?.label}</span>
                        <span>{dataReport.pendapatan?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.pendapatan?.total))})` : currencyFormat(dataReport.pendapatan?.total)}</span>
                      </div>
                    </div>
                    {/* /// */}
                    <div>
                      <div className="fw-bold p-2 border-bottom bg-light">{dataReport.bebanPokokPendapatan?.label}</div>
                      <div style={{ marginLeft: "20px" }}>
                        {dataReport.bebanPokokPendapatan?.data.map((account, i) => {
                          return (
                            <div key={account.code} className="p-2 d-flex justify-content-between align-items-center border-bottom">
                              <span>
                                {account.code} - {account.name}
                              </span>
                              {account.headerSaldo < 0 ? `(${currencyFormat(Math.abs(account.headerSaldo))})` : currencyFormat(account.headerSaldo)}
                            </div>
                          );
                        })}
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Total dari {dataReport.bebanPokokPendapatan?.label}</span>
                        <span>{dataReport.bebanPokokPendapatan?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.bebanPokokPendapatan?.total))})` : currencyFormat(dataReport.bebanPokokPendapatan?.total)}</span>
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Laba Kotor</span>
                        <span>{dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total))})` : currencyFormat(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total)}</span>
                      </div>
                    </div>
                    {/* /// */}
                    <div>
                      <div className="fw-bold p-2 border-bottom bg-light">{dataReport.bebanOperasional?.label}</div>
                      <div style={{ marginLeft: "20px" }}>
                        {dataReport.bebanOperasional?.data.map((account, i) => {
                          return (
                            <div key={account.code} className="p-2 d-flex justify-content-between align-items-center border-bottom">
                              <span>
                                {account.code} - {account.name}
                              </span>
                              {account.headerSaldo < 0 ? `(${currencyFormat(Math.abs(account.headerSaldo))})` : currencyFormat(account.headerSaldo)}
                            </div>
                          );
                        })}
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Total dari {dataReport.bebanOperasional?.label}</span>
                        <span>{dataReport.bebanOperasional?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.bebanOperasional?.total))})` : currencyFormat(dataReport.bebanOperasional?.total)}</span>
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Laba Operasional</span>
                        <span>{dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total))})` : currencyFormat(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total)}</span>
                      </div>
                    </div>
                    {/* /// */}
                    <div>
                      <div className="fw-bold p-2 border-bottom bg-light">{"Pendapatan (Beban Lain-lain)"}</div>
                      <div style={{ marginLeft: "20px" }}>
                        <div className="fw-bold p-2 border-bottom">{dataReport.pendapatanLainnya?.label}</div>
                        <div style={{ marginLeft: "40px" }}>
                          {dataReport.pendapatanLainnya?.data.map((account, i) => {
                            return (
                              <div key={account.code} className="p-2 d-flex justify-content-between align-items-center border-bottom">
                                <span>
                                  {account.code} - {account.name}
                                </span>
                                {account.headerSaldo < 0 ? `(${currencyFormat(Math.abs(account.headerSaldo))})` : currencyFormat(account.headerSaldo)}
                              </div>
                            );
                          })}
                        </div>
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Total dari Pendapatan (Beban Lain-lain)</span>
                        <span>{dataReport.pendapatanLainnya?.total < 0 ? `(${currencyFormat(Math.abs(dataReport.pendapatanLainnya?.total))})` : currencyFormat(dataReport.pendapatanLainnya?.total)}</span>
                      </div>
                      <div className="p-2 border-top fw-bold d-flex justify-content-between align-items-center">
                        <span>Laba (Rugi)</span>
                        <span>
                          {dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total + dataReport.pendapatanLainnya?.total < 0
                            ? `(${currencyFormat(Math.abs(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total + dataReport.pendapatanLainnya?.total))})`
                            : currencyFormat(dataReport.pendapatan?.total - dataReport.bebanPokokPendapatan?.total - dataReport.bebanOperasional?.total + dataReport.pendapatanLainnya?.total)}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ProfitLoss;
